export const dataTest = process.env.VUE_APP_API_TEST
export const dataApi = process.env.VUE_APP_API_BE
export const appChat = process.env.VUE_APP_CHAT_API_BE

class BaseUrl {
    url = dataApi
    mytest = dataTest
    myApi = dataApi
    apiChat = appChat
}
export default new BaseUrl();
